import { useCallback, useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import {
    ViewModelForm,
} from '@xengage/gw-portals-viewmodel-react';
import { DataTable, DisplayColumn } from '@jutro/legacy/datatable';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { Icon, ModalNextContext } from '@jutro/components';
import { useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import styles from './AddNewUser.module.scss';
import metadata from './AddNewUser.metadata.json5';
import messages from '../UserAdministrationPage.messages';
import enrollmentData from '../util/userenrollment.json5';
import { PolicyService } from 'gw-capability-policy';
import { EnrollmentService } from 'gw-capability-policyenrollment';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { LoaderExt } from 'gw-components-platform-react';
import useGoogleAnalytics from '../../../hooks/useGoogleAnalytics';




import { Button } from '@jutro/legacy/components';




function AddNewUser(props) {
    const {
        userdata,
        newUser,
        history,
        history: {
            location: { state }
        }
    } = props


    const auth = useAuthentication();
    const { authHeader } = useAuthentication();
    const translator = useTranslator();
    const modalNext = useContext(ModalNextContext);
    const [addAccountSelected, setAddAccountSelected] = useState([]);
    const { refreshData } = useDataRefresh();
    const [allAccountsButtonClick, setAllAccountsButtonClick] = useState(false);
    const [addAllaccountsContent, setAddAllaccountsContent] = useState("Add All Accounts");
    const [invoiceStreamArray, setInvoiceStreamArray] = useState([]);
    const [buttonTextValue, setButtonTextValue] = useState("Add");
    const [selectedInvoiceStreamName, setSelectedInvoiceStreamName] = useState();
    const [selectedAddRemoveArray, setSelectedAddRemoveArray] = useState([]);
    const [finalArray, setFinalArray] = useState([]);

    const grantData = [
        {
            "access": "BASIC",
            "description": "View Resources/FAQ",
            "isAccessGranted": true,
        },
        {
            "access": "POLICY",
            "description": "View policy details and policy documents, create Certificates of Insurance",
            "isAccessGranted": false,
        },
        {
            "access": "BILLING",
            "description": "Make payments, view invoices",
            "isAccessGranted": false,
        },
        {
            "access": "PAYROLL",
            "description": "Enter payroll reports, view payroll documents",
            "isAccessGranted": false,
        },
        {
            "access": "CLAIM",
            "description": "File a new claim, view claim notes and reports",
            "isAccessGranted": false,
        },
        {
            "access": "USERADMIN",
            "description": "Add and remove users, change user permissions, and all other authorities",
            "isAccessGranted": false,
        }
    ]

    const [enrollment, setEnrollment] = useState([enrollmentData]);
    const [authData, setAuthData] = useState(grantData);


    const [isLoading, setLoadingState] = useState(false);
    const [isUserValid, setIsUserValid] = useState(false);
    const [emailValidation, setEmailValidation] = useState('');
    const [addUserVM, setAddUserVM] = useState({});
    const [isEnrolled, setIsEnrolled] = useState(false);
    const [selectedNotificationList, setSelectedNotificationList] = useState([]);
    const [usersListData, setUsersListData] = useState(null);
    const [existsInExternalIDP, setExistsInExternalIDP] = useState(null);
    const [existingID, setexistingID] = useState(null)
    const [notificationList, setNotificationList] = useState([]);
    const [disableLossRunSubscription, setDisableLossRunSubscription] = useState(false);
    const [accountNumber, setAccountNumber] = useState('');
    const [trackGAPageView] = useGoogleAnalytics();
    const [trackCount, setTrackCount] = useState(0)
    const [adduserDataset, setAdduserDataset] = useState([]);
    const [accountROles, setAccountRolls] = useState([]);
    const [invoiceStreamSelectedRowVal, setInvoiceStreamSelectedRowVal] = useState([]);
    const [invFlag, setInvFlag] = useState(false);
    const [invoiceStreamNames,setInvoiceStreamNames] = useState([]);
    const NotificationDescription = {
        BillingInvoiceReady: {
            name: "Invoice Ready",
            value: "An invoice has billed and is ready"
        },
        BillingInvoiceReminder: {
            name: "Invoice Reminder",
            value: "An invoice is unpaid and due soon"
        },
        NOC: {
            name: "Notice of Cancellation",
            value: "A Notice of Cancellation has been generated"
        },
        PayrollReport: {
            name: "Payroll Reminder",
            value: "A payroll report is unfinished and due soon"
        },
        ClaimsUpdate: {
            name: "Claims Update",
            value: "A claim has updated with change to status, reserves or maximum medical improvement"
        },
        NewDocument: {
            name: "New Document",
            value: "An account/policy document has been posted"
        },
        LossRunSubscription: {
            name: "Loss Run Subscription (PDF)",
            value: "Receive loss run report while at least one policy is in force"
        },        
        LossRunSubscriptionXL: {
            name: "Loss Run Subscription (EXCEL)",
            value: "Receive loss run report while at least one policy is in force"
        }
    };

    const getPublishedNotifications = useCallback(() => {
        EnrollmentService.getPublishedNotifications(authHeader).then((result) => {
            setNotificationList(result?.filter((item) => item?.itemName !== "ClaimsUpdate"));
        }).catch(() => {

        });
    }, [EnrollmentService, authHeader]);

    const getActivePolicyForLossRunSubscription = useCallback(() => {
        PolicyService.getAllAvailableAccountPolicySummaries_Ext(authHeader).then((policyData) => {
            if (policyData) {
                const authorityRegex = /^guidewire\.edge\.(.*)\.(.*)\.(.*)$/g;
                const grantedAuthorities = auth.userInfo.grantedAuthorities;
                const match = authorityRegex.exec(grantedAuthorities[0]);
                setAccountNumber((policyData[0]?.accountNumber) ?? match[2])
                let showFlag = 0;
                for (let i = 0; i < policyData.length; i++) {
                    if (policyData[i].displayStatus === "In Force" || policyData[i].displayStatus === "Scheduled" || policyData[i].displayStatus === "Pending Cancellation") {                        
                        showFlag++;
                        break;                        
                    }
                }
                if (showFlag === 0) {
                    setDisableLossRunSubscription(true);
                }
            }
        }).catch(() => {

        });
    }, [PolicyService, authHeader]);

    useEffect(() => {
        getActivePolicyForLossRunSubscription();
        getPublishedNotifications();
        getAllAccountsforCurrentUser();
    }, [])
    useEffect(()=>{

    },[invoiceStreamSelectedRowVal])

    useEffect(() => {
        trackGAPageView('/adduser', 'Add New User');
    }, [])

    useEffect(() => {

    }, [buttonTextValue])
    useEffect(()=>{

    },[invFlag])

    const getAccountNumber = (item) => {
        return <div style={{fontSize :"1.2rem"}}>{item.accountNumber}</div>;
    }

    const getAccountName = (item) => {
        return <div style={{fontSize :"1.2rem"}}>{item.accountName}</div>
    }
    useEffect(() => {

    }, [adduserDataset])
    useEffect(() => {

    }, [invoiceStreamSelectedRowVal])


    const getAllAccountsforCurrentUser = useCallback(async () => {
        const userInfo = await EnrollmentService.getUser(auth.userInfo.email, authHeader)
            .then((userInfo) => {
                
                // Logic for invoiceStreams Access
                // eslint-disable-next-line react-hooks/exhaustive-deps, no-const-assign
                for(let i = 0;i < userInfo.accountInformation.length; i ++)
                {
                    userInfo.accountInformation[i].invoiceStreamCount = userInfo.accountInformation[i].invoiceStreams.length;

                    const b =[];
                    // userInfo.accountInformation[i].invoiceStreams1 =[];
                    const result  =userInfo.roles.filter((o)=>o.access === userInfo.accountInformation[i].accountNumber);
                    if(result.length !==0){
                        const streamResult = result.reduce((catsSoFar, { access, description }) => {
                            if (!catsSoFar[access]) catsSoFar[access] = [];
                            catsSoFar[access].push(description);
                            return catsSoFar;
                        }, {});
                        const gArray = Object.entries(streamResult);
                    
                        // eslint-disable-next-line array-callback-return
                        // userInfo?.accountInformation[i]?.invoiceStreams.map((k)=>{
                        //     const v =k.replace(/\s/g, '');
                        //     const resultFilter = gArray[0][1].includes(v);
                        //     if(resultFilter===false){
                        //         delete userInfo.accountInformation[i].invoiceStreams[k] 
                        //     }else{ 
                        //         b.push(k);  
                        //     }
                        // })
                        // eslint-disable-next-line guard-for-in
                        for (const inv in userInfo?.accountInformation[i]?.invoiceStreamMap) {
                            const invName = userInfo?.accountInformation[i]?.invoiceStreamMap[inv];
                            const resultFilter = gArray[0][1].includes(inv);
                            if(resultFilter===true){
                                b.push(invName); 
                            }
                        }   
                    }
                    userInfo.accountInformation[i].invoiceStreams =[];
                    userInfo.accountInformation[i].invoiceStreams = b;
                    userInfo.accountInformation[i].accessTrueMultiInvoiceCount =userInfo.accountInformation[i].invoiceStreams.length;
                }
                // Logic for invoiceStreams Access
                // eslint-disable-next-line array-callback-return
                userInfo.accountInformation.map((itemRecord) => {
                    itemRecord.buttonText = "Add Account";
                })
                setAdduserDataset(userInfo.accountInformation);
            })


    }, [auth.userInfo.email, authHeader])

    const updateContactDetails = useCallback(() => {
        if (isUserValid) {

            if (addUserVM.firstName === '' || addUserVM.firstName === null || typeof addUserVM.firstName === 'undefined' || !addUserVM.firstName.replace(/\s/g, '').length) {
                return setEmailValidation(translator(messages.firstNameValidation))
            }
            if (addUserVM.lastName === '' || addUserVM.lastName === null || typeof addUserVM.lastName === 'undefined' || !addUserVM.lastName.replace(/\s/g, '').length) {
                return setEmailValidation(translator(messages.lastNameValidation))
            }

            const options = isEnrolled ? [{
                portalOptInItemID: 1,
                itemName: "Paperless",
            }] : [];

            const grantedAuthority = [];

            if (addAllaccountsContent === "Remove All Accounts" || adduserDataset.length === 1) {
                // const grantedAuthority = [];
                // eslint-disable-next-line array-callback-return
                adduserDataset.map((itemValue) => {
                    grantedAuthority.push({
                        accountNumber: itemValue.accountNumber,
                        accountName: itemValue.accountName,
                        authority: authData
                    })
                })
            } else {
                // adduserDataset
                // const grantedAuthority = [];
                // eslint-disable-next-line array-callback-return
                addAccountSelected.map((itemValue) => {
                    grantedAuthority.push({
                        accountNumber: itemValue.accountNumber,
                        accountName: itemValue.accountName,
                        authority: authData
                    })
                })

            }

            if(grantedAuthority.length>0){
                // eslint-disable-next-line array-callback-return
                invoiceStreamArray.map((removeProp)=>{
                    delete removeProp.btnText
                })
                // eslint-disable-next-line array-callback-return
                grantedAuthority.map((grantArryItem)=>{
                    const accountStreamResult =  invoiceStreamArray.filter((i) => i.access === grantArryItem.accountNumber);
                    let finalAccountStreamResult = []

                    for(let i = 0;i < accountStreamResult.length; i ++) {
                        if(finalAccountStreamResult.filter((e) => e.invoiceId === accountStreamResult[i].invoiceId).length === 0){
                            finalAccountStreamResult.push(accountStreamResult[i])
                        }
                    }
                    if(accountStreamResult !==undefined){
                        grantArryItem.authority =  [...grantArryItem.authority, ...finalAccountStreamResult];  
                    }
                })
            }

            const data =
            {
                userName: addUserVM.userEmail,
                userType: "useradmin",
                verified: true,
                active: true,
                // newPasswordEntryUrl: "https://ceintv10.copperpoint.com/CustomerEngage-Account_Management/html/#/auth/resetpassword",
                name: {
                    givenName: addUserVM.firstName,
                    familyName: addUserVM.lastName
                },
                emails: [
                    {
                        value: addUserVM.userEmail,
                        primary: true
                    }
                ],
                grantedAuthorities: grantedAuthority,
                accountNumber: accountNumber,
                optIns: selectedNotificationList,
                sourceApplication_CPIC: "CEAM",
                existsInExternalIDP: existsInExternalIDP
            }
            
            if (existingID !== null) {
                data.id = existingID
            }
            setLoadingState(true)
           
            data.optIns?.map((invoices)=>{
                invoices.invoiceStreamNames=invoiceStreamNames;
            })
            EnrollmentService.addUser(data, authHeader)
                .then((result) => {
                    if (!_.isEmpty(result)) {

                        return history.push({
                            pathname: `/user-administration`,
                            search: `?created=success`,

                        });

                    }
                })
                .finally(() => {
                    setLoadingState(false);

                })

        }
        else {
            const re = /\S+@\S+\.\S+/;
            if (!re.test(addUserVM.userEmail)) {
                return setEmailValidation(translator(messages.emailValidation));
            }

            const data = [auth.userInfo.email, addUserVM.userEmail];

            EnrollmentService.validateEmailAddress(data, authHeader)
                .then((result) => {
                    if (result) {
                        setIsUserValid(result);
                        addUserVM.firstAddUserButton = 'firstAddUserButton';
                        setEmailValidation('');
                        setExistsInExternalIDP(result.existsInExternalIDP);
                        if (result.existsInExternalIDP && !_.isEmpty(result.name)) {
                            addUserVM.firstName = result.name.givenName
                            addUserVM.lastName = result.name.familyName
                            setAddUserVM(addUserVM);
                            setEmailValidation('');
                            setexistingID(result.id)
                        }
                    }
                    else {
                        setEmailValidation(translator(messages.emailAlreadyRegistered))
                    }

                }).catch(() => {
                    setEmailValidation(translator(messages.emailAlreadyRegistered))
                })
                .finally(() => {
                    setLoadingState(false);
                });

        }
    }, [isUserValid, addUserVM, isEnrolled, authData, accountNumber, selectedNotificationList, existsInExternalIDP, existingID, authHeader, translator, history, auth.userInfo.email, emailValidation]);

    const getCell = (items, index, property) => {
        return !_.isObject(items[property.id]) ? <div style={{fontSize :"1.2rem"}}>{items[property.id]}</div> : null;
    };

    const getNotificationName = (item) => {
        return <div style={{fontSize :"1.2rem"}}>{NotificationDescription[item?.itemName]?.name}</div>;        
    };
    const getNotificationDesc = (item) => {
        return <div style={{fontSize :"1.2rem"}}>{NotificationDescription[item?.itemName]?.value}</div>;        
    };
    const getNotificationAccess = (item) => {
        const notificationCheck = selectedNotificationList.find((i) => i.itemName === item.itemName);
        if (notificationCheck) {
            return <Icon icon="mi-check" />;
        }
    };
    const addNotificationAlert = useCallback((e, item) => {
        e.preventDefault();
        const newList = _.clone(selectedNotificationList);
        newList.push(item);
        setSelectedNotificationList(newList);
    }, [selectedNotificationList]);

    const removeNotificationAlert = (e, item) => {
        e.preventDefault();
        const newList = _.clone(selectedNotificationList);
        const index = newList.indexOf(item);
        newList.splice(index, 1);
        setSelectedNotificationList(newList);
    };
    const getNotificationAction = (item, index) => {
        const notificationCheck = selectedNotificationList.find((i) => i.itemName === item.itemName);
        if (notificationCheck) {
            return <Button style={{ width: "152px", background: "#003057" }} id={index} onClick={(e) => removeNotificationAlert(e, item)}>Remove Receipt</Button>;
        }
        return <Button disabled={disableLossRunSubscription && (item.itemName === 'LossRunSubscription' || item.itemName === 'LossRunSubscriptionXL')} style={{ width: "152px" }} id={index} onClick={(e) => addNotificationAlert(e, item)}>Add Receipt</Button>;

    };

    const renderAccess = item => {
        if (item.access === 'yes') {
            return <Icon icon="mi-check" />;
        }
    };

    const addAllAccountsClick = useCallback(() => {
       
        let addAllInvoices=[]
        if(addAllaccountsContent==="Add All Accounts"){
            adduserDataset.map((items)=>{
                items.invoiceStreams?.map((inames)=>{
                    addAllInvoices.push(inames)
                })
            })
            setInvoiceStreamNames(addAllInvoices)
        }else{
            setInvoiceStreamNames([]);
        }
        if (addAllaccountsContent === "Remove All Accounts") {
            setAddAllaccountsContent("Add All Accounts");
            addUserVM.allAccounButton = "Disabled"
            setInvoiceStreamArray([]);
            // // eslint-disable-next-line no-const-assign
            // invoiceStreamArray =[]
            invoiceStreamArray.splice(0, invoiceStreamArray.length);
            setAddAccountSelected([]);
            setInvoiceStreamArray([...invoiceStreamArray]);
        } else if (addAllaccountsContent === "Add All Accounts") {
            setAddAllaccountsContent("Remove All Accounts");
            setAddAccountSelected(adduserDataset);
            addUserVM.allAccounButton = "Enabled"
            setInvoiceStreamArray([]);
            
            invoiceStreamArray.splice(0, invoiceStreamArray.length);
            setInvoiceStreamArray([...invoiceStreamArray]);
            // eslint-disable-next-line array-callback-return
            adduserDataset.map((itemLooping)=>{
                // eslint-disable-next-line array-callback-return
                itemLooping.invoiceStreams.map((subItemLoop)=>{
                    // eslint-disable-next-line no-const-assign
                    invoiceStreamArray.push({
                        access: itemLooping.accountNumber,
                        description: subItemLoop.replace(/\s/g, ''),
                        invoiceId: Object.keys(itemLooping.invoiceStreamMap).find((key) => itemLooping.invoiceStreamMap[key] === subItemLoop),
                        isAccessGranted: true,
                        btnText:"Remove"
                    })
                })
            })

            setInvoiceStreamArray(invoiceStreamArray);  
        }
        
        // setAllAccountsButtonClick(true);

        // eslint-disable-next-line array-callback-return
        adduserDataset.map((txc) => {
            if (addAllaccountsContent === "Remove All Accounts") {
                txc.buttonText = "Add Account"
            } else {
                txc.buttonText = "Remove Account"
            }

        })
        refreshData();
        // setInvFlag(false);
        
    }, [addAllaccountsContent, addUserVM, adduserDataset, invoiceStreamArray, refreshData])

    useEffect(() => {
        if (adduserDataset.length === 1) {
            let invoiceStreamArray = []

            setAddAccountSelected(adduserDataset)            
            adduserDataset[0].invoiceStreams.forEach((inv) => {
                invoiceStreamArray.push({
                    access: adduserDataset[0].accountNumber,
                    description: inv.replace(/\s/g, ''),
                    invoiceId: Object.keys(adduserDataset[0].invoiceStreamMap).find((key) => adduserDataset[0].invoiceStreamMap[key] === inv),
                    isAccessGranted: true,
                    btnText:"Remove"
                })                
            }); 
            setInvoiceStreamArray(invoiceStreamArray)         
        }
    }, [addUserVM, adduserDataset, setInvoiceStreamArray])

    const addAccountButtonClick = useCallback((e, rowId, item) => {
        //setTrackCount(trackCount+1)
        const invoiceDisplayNames=[]
        let removeInvoiceNames=[]
        if(item.buttonText === "Add Account"){
            item.invoiceStreams.map((items)=>{
                invoiceDisplayNames.push(items)
            })
            setInvoiceStreamNames([...invoiceDisplayNames,...invoiceStreamNames])
        }
        else{
            removeInvoiceNames=invoiceStreamNames.filter((names)=>!item.invoiceStreams.includes(names))
            setInvoiceStreamNames(removeInvoiceNames)
        }
        
        if (item.buttonText === "Add Account" && addAccountSelected.indexOf(item) === -1) {
            item.buttonText = "Remove Account"

            addAccountSelected.push(item)
            // accountROles.push({item.accountNumber:item.});

            setAddAccountSelected(addAccountSelected)
            if (addAccountSelected.length === adduserDataset.length) {
                setAddAllaccountsContent("Remove All Accounts");
            }
            
            if(invoiceStreamArray.length===0){
                // eslint-disable-next-line array-callback-return
                item.invoiceStreams.map((itm)=>{
                    invoiceStreamArray.push({
                        access: item.accountNumber,
                        description: itm.replace(/\s/g, ''),
                        invoiceId: Object.keys(item.invoiceStreamMap).find((key) => item.invoiceStreamMap[key] === itm),
                        isAccessGranted: true,
                        btnText:"Remove"
                    })
                })
                setInvoiceStreamArray(invoiceStreamArray);
            }
            else{
                const selectedAddRemoveArrayFind = invoiceStreamArray.find((i) => i?.access === item?.accountNumber);
                if(selectedAddRemoveArrayFind === undefined){
                    // eslint-disable-next-line array-callback-return
                    item.invoiceStreams.map((itm)=>{
                        invoiceStreamArray.push({
                            access: item.accountNumber,
                            description: itm.replace(/\s/g, ''),
                            invoiceId: Object.keys(item.invoiceStreamMap).find((key) => item.invoiceStreamMap[key] === itm),
                            isAccessGranted: true,
                            btnText:"Remove"
                        })
                    })
                }
                setInvoiceStreamArray(invoiceStreamArray);
            }
            

        } else if (item.buttonText === "Remove Account") {
            item.buttonText = "Add Account"
            const tempRemoveAccount = [];
            // eslint-disable-next-line array-callback-return
            addAccountSelected.map((itemNumber) => {
                if (itemNumber.accountNumber !== item.accountNumber) {
                    tempRemoveAccount.push(itemNumber)
                }

            })
            setAddAccountSelected(tempRemoveAccount)
            // eslint-disable-next-line array-callback-return
            addAccountSelected.map((itemButton) => {
                if (itemButton.buttonText === 'Add Account') {
                    setAddAllaccountsContent("Add All Accounts");
                }

            })
            // eslint-disable-next-line array-callback-return
            item?.invoiceStreamName?.map((buttonVl)=>{
                buttonVl.buttonValue = "Remove"
            })
            
            // eslint-disable-next-line react-hooks/exhaustive-deps, no-const-assign
            for(let i = 0;i < invoiceStreamArray.length; i ++)
            {
                if(invoiceStreamArray[i]?.access === item?.accountNumber)
                {
                    // invoiceStreamArray.splice(i, 1);
                    // i--;  
                    delete invoiceStreamArray[i]
                }
            }

        }
        refreshData()

    }, [addAccountSelected, adduserDataset.length, invoiceStreamArray, refreshData,adduserDataset])


    const updateAccess = useCallback((e, rowId) => {
        e.preventDefault();
        setLoadingState(true)
        let updatedItems = [...authData];
        let updatedItem = updatedItems[rowId];
        updatedItem.isAccessGranted = !updatedItem.isAccessGranted
        updatedItems[rowId] = updatedItem;
        setAuthData(updatedItems)
        setLoadingState(false)

    }, [authData]);

    const renderAction = (item, index) => {
        if (item.action === 'na' || item.userRole === 'Basic User') {
            return <Icon icon="mi-check" />;
        } else if (item.action === 'yes') {
            return <Button style={{ width: "152px" }} id={index} onClick={(e) => updateAccess(e, index, item)}>Grant</Button>;
        } else if (item.action === 'no') {
            return <Button style={{ width: "152px", background: "#003057" }} id={index} onClick={(e) => updateAccess(e, index, item)}>Remove</Button>;
        }
    };

    const renderEnrolledAccess = (item, index) => {
        if (item.access === 'yes') {
            setIsEnrolled(true);
            return <Icon icon="mi-check" />;
        }
    }

    const updateEnrollmentAccess = useCallback((e, rowId) => {
        e.preventDefault();
        setLoadingState(true)
        let updatedItems = [...enrollment];
        let updatedItem = updatedItems[0];
        updatedItem.action = updatedItem.action === 'yes' ? 'no' : 'yes';
        updatedItem.access = updatedItem.access === 'yes' ? 'no' : 'yes';
        updatedItems[0] = updatedItem;

        setEnrollment(updatedItems)
        setLoadingState(false)

    }, [enrollment]);

    const renderEnrolledAction = (item, index) => {
        if (item.action === 'yes') {
            return <Button style={{ width: "152px" }} id={index} onClick={(e) => updateEnrollmentAccess(e, index, item)}>Grant</Button>;
        }
        else {
            return <Button style={{ width: "152px" }} id={index} onClick={(e) => updateEnrollmentAccess(e, index, item)}>Remove</Button>;

        }
    }

    const renderDescription = item => {

        return <div className={styles.enrollDescrList}>{item.itemName}</div>;
    };

    const grantAuthData = (() => {

        return authData.map(role => {
            const grantrole = role.access;
            const acc = role.isAccessGranted === true ? 'yes' : 'no';
            const act = role.isAccessGranted === true ? 'no' : 'yes';
            return {
                userRole: translator(messages[grantrole]),
                authDesc: role.description,
                access: acc,
                action: act,
            };
        });
    });

    const addInvoiceStream = useCallback((e, item) => {
        setInvFlag(true);
        let removeInvoiceNames=[];         
        if(item.buttonValue === "Remove"){
            removeInvoiceNames=invoiceStreamNames.filter((names)=>names!==item.invName)
            setInvoiceStreamNames(removeInvoiceNames)
            // eslint-disable-next-line react-hooks/exhaustive-deps, no-const-assign
            for(let i = 0;i < invoiceStreamArray.length; i ++)
            {        
                if(invoiceStreamArray[i]?.invoiceId === item?.invId)
                {
                    invoiceStreamArray.splice(i,1)
                    
                    // if(invoiceStreamNameSelected ==="Remove"){
                    //     invoiceStreamArray[i].btnText ="Add";
                    //     // invoiceStreamArray.splice(i, 1);
                    //     // i--; 
                    // }else{
                    //     invoiceStreamArray[i].btnText ="Remove";
                    // }

                }
            }
        }  else if(item.buttonValue === "Add"){
            setInvoiceStreamNames([item.invName,...invoiceStreamNames])
            invoiceStreamArray.push({
                access: item.accountNumber,
                description: item.invName,
                invoiceId: item.invId,
                isAccessGranted: true,
                btnText:"Remove"
            })
        }      
        setInvoiceStreamArray(invoiceStreamArray)
        setSelectedInvoiceStreamName(item.invName);
        const filterSelectedAccountObject = adduserDataset.find((i) => i.accountNumber === item.accountNumber);

        // eslint-disable-next-line array-callback-return
        filterSelectedAccountObject.invoiceStreamName = filterSelectedAccountObject.invoiceStreamName.map((lpItem) => {
            if (lpItem.invId === item.invId) {
                const buttonValueText = lpItem.buttonValue === "Add" ? "Remove" : "Add";
                lpItem.buttonValue = buttonValueText;
               
            }
            return lpItem
        })
        const resultObject = filterSelectedAccountObject
        setInvoiceStreamSelectedRowVal([]);
        setInvoiceStreamSelectedRowVal(resultObject);

        refreshData();

    }, [adduserDataset, invoiceStreamArray, invoiceStreamNames, refreshData])

    const renderButtonAction = (item,tableDataValues) => {
        const filterData = tableDataValues?.filter((l)=>l?.buttonValue ==="Add");
       const buttonDisabled = (tableDataValues?.length - filterData?.length) ===1
        setInvFlag(true);
        if(item.buttonValue === "Add"){
            // eslint-disable-next-line react/react-in-jsx-scope
            return <Button style={{ "width": "152px" }} id={item.invName} onClick={(e) => addInvoiceStream(e, item)} disabled={item.buttonEnableDisabled !=="Enabled"}>{item.buttonValue}</Button>
            
        }
        // eslint-disable-next-line react/react-in-jsx-scope
        return <Button style={{ width: "152px", background: "#003057" }} id={item.invName} onClick={(e) => addInvoiceStream(e, item)} disabled={item.buttonEnableDisabled !=="Enabled" || buttonDisabled}>{item.buttonValue}</Button>

    }


    const renderRowData = (row) => {
        setInvFlag(false);

        setInvoiceStreamSelectedRowVal([]);
        setInvoiceStreamSelectedRowVal(row);
        let invoiceStreamArray = []
        let invNames = []
        if ((row.buttonText === "Remove Account" || adduserDataset.length === 1)&& row.invoiceStreamCount >0) {            
            if (row.invoiceStreamName === undefined) {
                row.invoiceStreamName = [];
                // eslint-disable-next-line array-callback-return
                row.invoiceStreams.map((itenm) => {
                    row.invoiceStreamName.push({
                        invName: itenm,
                        invId:Object.keys(row.invoiceStreamMap).find((key) => row.invoiceStreamMap[key] === itenm),
                        accountNumber: row.accountNumber,
                        buttonValue: "Remove",
                        buttonEnableDisabled:(row.invoiceStreamCount > 1 && row.accessTrueMultiInvoiceCount ===1)?"Disabled":"Enabled"
                    })
                    if(adduserDataset.length === 1){
                        invoiceStreamArray.push({
                            access: row.accountNumber,
                            description: itenm.replace(/\s/g, ''),
                            invoiceId: Object.keys(row.invoiceStreamMap).find((key) => row.invoiceStreamMap[key] === itenm),
                            isAccessGranted: true,
                            btnText:"Remove"
                        })
                        invNames.push(itenm)   
                    }                                     
                })
                if(adduserDataset.length === 1){
                    setInvoiceStreamArray(invoiceStreamArray);
                    setInvoiceStreamNames(invNames)
                }                
            }

            if (invFlag === false) {
                row.invoiceStreamName = [];
                // eslint-disable-next-line array-callback-return
                row.invoiceStreams.map((itenm) => {
                    row.invoiceStreamName.push({
                        invName: itenm,
                        invId:Object.keys(row.invoiceStreamMap).find((key) => row.invoiceStreamMap[key] === itenm),
                        accountNumber: row.accountNumber,
                        buttonValue: itenm.buttonValue === undefined ? "Remove" : itenm.buttonValue,
                        buttonEnableDisabled:(row.invoiceStreamCount > 1 && row.accessTrueMultiInvoiceCount ===1)?"Disabled":"Enabled"
                    })
                    if(adduserDataset.length === 1){
                        invoiceStreamArray.push({
                            access: row.accountNumber,
                            description: itenm.replace(/\s/g, ''),
                            invoiceId: Object.keys(row.invoiceStreamMap).find((key) => row.invoiceStreamMap[key] === itenm),
                            isAccessGranted: true,
                            btnText:itenm.buttonValue === undefined ? "Remove" : itenm.buttonValue
                        })
                    }                    
                })
                if(adduserDataset.length === 1){
                    setInvoiceStreamArray(invoiceStreamArray);    
                }
                
            }
        //     const arrayT = []
        
        // const filterArrayVal = row?.invoiceStreamName?.filter((m)=>m?.buttonValue ==="Remove")
        // if (filterArrayVal?.length !== row?.invoiceStreams?.length) {
        //     // eslint-disable-next-line array-callback-return
        //     row?.invoiceStreamName.map((k) => {
        //         if (k?.buttonValue === "Remove") {
        //             arrayT.push(k)
        //         }
        //     })
        //     if(arrayT?.length ===row?.invoiceStreams?.length-1){
        //         row.invoiceStreamName[row?.invoiceStreams?.length].buttonEnableDisabled ="Disabled"
        //     }
        // }
        // console.log(arrayT);
        
        if(row.invoiceStreamCount > 1){
            return (
                // eslint-disable-next-line react/react-in-jsx-scope
                <DataTable
                    columnsConfigurable={false}
                    data={row.invoiceStreamName}

                    defaultConfig={{
                        page: 0,
                        pageSize: 10
                    }}
                    id="basic"
                    showPagination={false}
                    showSearch={false}
                    isSorted={false}
                >
                    <DisplayColumn
                        header="Invoice Name"
                        id="invName"
                        cell={(row) => {  
                            return <span className={styles.columnFontCls}>{row.invName}</span>;
                        }}
                        textAlign="left"                    
                        columnProportion={0.69}
                    />
                    <DisplayColumn
                        header="Action"
                        id="AddRemoveBtn"
                        sortable={false}
                        renderCell={(item) => renderButtonAction(item,row.invoiceStreamName)}
                        textAlign="left"
                        columnProportion={0.23}

                    />

                </DataTable>
            )
        }
            return (<></>)
        
           
        }
    }



    const renderAddAccountButton = useCallback((item, index) => {

        // eslint-disable-next-line react/react-in-jsx-scope
        return <Button style={{ width: "152px", background: (item.buttonText === "Remove Account") || adduserDataset.length === 1 ? 'rgb(0, 48, 87)' : "" }}
            disabled={(adduserDataset.length === 1)}
            id="Add Account"
            onClick={(e) => addAccountButtonClick(e, index, item)}>{adduserDataset.length === 1 ? "Remove Account" : item.buttonText}</Button>;


    }, [addAccountButtonClick, addAllaccountsContent, adduserDataset.length])

    const handleCancel = useCallback(() => {
        modalNext
            .showConfirm({
                title: messages.cancelEditTitle,
                message: messages.cancelEditMessage,
                status: 'info',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.yesModel,
                cancelButtonText: commonMessages.noModel,
            })
            .then(results => {
                if (results === 'confirm') {
                    return history.push('/user-administration')
                }
            }, _.noop);
    }, [modalNext]);

    const writeValue = useCallback(
        (value, path) =>
            setAddUserVM({
                ...addUserVM,
                [path]: value,
            }),
        [addUserVM]
    );

    if (isLoading) {
        return <LoaderExt loaded={!isLoading} />;
    }
    const overrides = {
        addNewUserContainer: {
        },
        newUserContainer: {
            visible: isUserValid,
        },
        useremailId: {
            disabled: isUserValid,
        },
        userRoleTable: {
            data: grantAuthData(),
        },
        enrollmentTable: {
            data: notificationList || [],
        },
        validationMessage: {
            content: !_.isEmpty(emailValidation) ? emailValidation : ''
        },
        addallusersTable: {
            data: adduserDataset,
        },
        addAllAccountsBtn: {
            content: addAllaccountsContent,
            className: addAllaccountsContent === "Remove All Accounts" ? 'addAllAccountsClass' : '',
            disabled: adduserDataset.length === 1,
            visible:false
        },
        saveButton: {
            disabled: (addUserVM.firstAddUserButton === 'firstAddUserButton' && addAccountSelected.length === 0 && addAllaccountsContent === "Add All Accounts") || (addAllaccountsContent !== "Remove All Accounts" && addUserVM.allAccounButton === "Enabled" && addAccountSelected.length === 0)
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {},
        resolveCallbackMap: {
            updateContactDetails,
            writeValue,
            getUserRole: getCell,
            getAutorityDescription: getCell,
            getAccess: renderAccess,
            getAction: renderAction,
            getActivity: getCell,
            getDescription: renderDescription,
            renderEnrolled: renderEnrolledAccess,
            renderEnrolledAction: renderEnrolledAction,
            updateAccess,
            getNotificationName,
            getNotificationDesc,
            getNotificationAccess,
            getNotificationAction,
            handleCancel,
            renderAddAccountButton: renderAddAccountButton,
            getAllAccountsforCurrentUser,
            getAccountNumber,
            getAccountName,
            // addAccountButtonClick
            addAllAccountsClick: addAllAccountsClick,
            addInvoiceStream,
            renderRowData

        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={addUserVM}
            overrideProps={overrides}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

export default withRouter(AddNewUser);

